/* nplus-qualify.js — <nplus-qualify> cash qualify form.
   Captures a lead and creates a Shopify draft order. Takes no payment.
   Loaded after nplus-leasing-service.js. Uses window.nplusLeasing.createLeasingInquiry.
   Classic script, no dependencies beyond that service. */
(function () {
  'use strict';

  var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
  var BILLING_REQUIRED = ['address1', 'city', 'province', 'zip', 'country'];

  class NplusQualify extends HTMLElement {
    connectedCallback() {
      if (this._connected) return; // guard against duplicate listeners on DOM re-insertion
      this._connected = true;
      this.cfg = this.readConfig();
      var self = this;

      // Size pills swap the bike variant without a section re-render, so the
      // render-time cfg.variantId goes stale. <nplus-buybox> broadcasts every
      // change — track it so the draft order carries the selected variant.
      this.variantId = this.cfg.variantId;
      document.addEventListener('nplus:bike-variant-change', function (e) {
        var id = e && e.detail && e.detail.variantId;
        if (id) self.variantId = id;
      });

      this.fields = {
        firstName: this.querySelector('[data-nplus-field="firstName"]'),
        lastName: this.querySelector('[data-nplus-field="lastName"]'),
        email: this.querySelector('[data-nplus-field="email"]'),
        phone: this.querySelector('[data-nplus-field="phone"]')
      };
      this.billing = {};
      Array.prototype.forEach.call(this.querySelectorAll('[data-nplus-billing]'), function (el) {
        self.billing[el.getAttribute('data-nplus-billing')] = el;
      });
      this.consentEl = this.querySelector('[data-nplus-consent]');
      this.submitEl = this.querySelector('[data-nplus-submit]');
      this.statusEl = this.querySelector('[data-nplus-status]');
      if (this.submitEl) this.submitEl.addEventListener('click', this.onSubmit.bind(this));
    }

    readConfig() {
      var el = this.querySelector('.nplus-qualify__config');
      if (!el) return {};
      try { return JSON.parse(el.textContent); } catch (e) { return {}; }
    }

    t(key, fallback) {
      var i18n = this.cfg && this.cfg.i18n;
      return (i18n && i18n[key]) || fallback;
    }

    setStatus(msg, isError) {
      if (!this.statusEl) return;
      this.statusEl.textContent = msg || '';
      this.statusEl.hidden = !msg;
      this.statusEl.classList.toggle('nplus-bb__status--error', !!isError);
    }
    setBusy(b) {
      if (!this.submitEl) return;
      this.submitEl.disabled = b;
      this.submitEl.setAttribute('aria-busy', b ? 'true' : 'false');
    }

    showFieldError(key, msg) {
      var el = this.querySelector('[data-nplus-error-for="' + key + '"]');
      if (el) { el.textContent = msg || this.t('required', 'Required'); el.hidden = false; }
    }
    clearFieldErrors() {
      Array.prototype.forEach.call(this.querySelectorAll('[data-nplus-error-for]'), function (e) { e.hidden = true; });
    }

    collect() {
      var f = this.fields, b = this.billing;
      var val = function (el) { return el ? el.value.trim() : ''; };
      var accessories = (window.nplusAccessories && typeof window.nplusAccessories.getSelection === 'function')
        ? window.nplusAccessories.getSelection() : [];
      return {
        productId: this.cfg.productId,
        variantId: this.variantId || this.cfg.variantId,
        customer: { firstName: val(f.firstName), lastName: val(f.lastName), email: val(f.email), phone: val(f.phone) },
        // Shipping address. The backend maps `billing` to both the draft's billing and shipping address.
        billing: { address1: val(b.address1), city: val(b.city), province: val(b.province), zip: val(b.zip), country: val(b.country) },
        accessories: accessories,
        consent: !!(this.consentEl && this.consentEl.checked),
        currency: this.cfg.presentmentCurrency,
        locale: this.cfg.locale,
        employerOptional: true,   // this form has no employer field; backend skips the requirement
        tag: 'order-inquiry',     // base draft tag — not a leasing inquiry
        source: this.cfg.source || 'cash-qualify' // second tag; per-template (bikes vs accessories)
      };
    }

    validate(payload) {
      this.clearFieldErrors();
      var ok = true;
      var fail = function (key, msg) { ok = false; this.showFieldError(key, msg); }.bind(this);
      var c = payload.customer;
      if (!c.firstName) fail('firstName');
      if (!c.lastName) fail('lastName');
      if (!c.phone) fail('phone');
      if (!c.email) fail('email'); else if (!EMAIL_RE.test(c.email)) fail('email', this.t('invalid_email', 'Enter a valid email'));
      BILLING_REQUIRED.forEach(function (k) { if (!payload.billing[k]) fail(k); });
      if (!payload.consent) fail('consent', this.t('consent_required', 'Consent is required to submit.'));
      return ok;
    }

    onSubmit() {
      this.setStatus('');
      if (!window.nplusLeasing) { this.setStatus(this.t('unavailable_service', 'Service unavailable. Please refresh.'), true); return; }
      var payload = this.collect();
      // No product identity means the Liquid config is broken or no variant is
      // available. Fail loud — submitting would create a lead with no bike on it.
      if (!payload.productId || !payload.variantId) { this.setStatus(this.t('unavailable_service', 'Service unavailable. Please refresh.'), true); return; }
      if (!this.validate(payload)) return;
      this.setBusy(true);
      var self = this;
      window.nplusLeasing.createLeasingInquiry(payload)
        .then(function () { self.showSuccess(); })
        .catch(function (err) {
          self.setStatus(err.message || self.t('submit_error', 'Could not submit your request. Please try again.'), true);
          self.setBusy(false);
        });
    }

    showSuccess() {
      var title = this.t('success_title', 'Request received');
      var body = this.t('success_body', 'Thanks — your request is in. Our team will be in touch shortly.');
      this.innerHTML = '<div class="nplus-qualify__success">'
        + '<span class="nplus-qualify__success-badge"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg></span>'
        + '<h3>' + title + '</h3><p>' + body + '</p></div>';
    }
  }

  if (!customElements.get('nplus-qualify')) {
    customElements.define('nplus-qualify', NplusQualify);
  }
})();
